// extracted by mini-css-extract-plugin
export default {"notfoundContainer":"NotFound_notfoundContainer__zBAff","notfoundLeft":"NotFound_notfoundLeft__h361B","notfoundRight":"NotFound_notfoundRight__eQjcQ"};